import React from 'react';
import PropTypes from 'prop-types';

import styles from '../article.module.css';

export const StyledAudio = ({
	id,
	audiopath,
	type,
	bleed,
	caption,
	captionenabled,
}) => {
	return (
		<Audio
			id={id}
			type={type}
			bleed={bleed === 'on'}
			caption={caption}
			captionEnabled={captionenabled === 'on'}
			audioPath={audiopath}
		/>
	);
};

StyledAudio.propTypes = {
	id: PropTypes.string,
	audiopath: PropTypes.string.isRequired,
	type: PropTypes.oneOf(['mp3']),
	bleed: PropTypes.string,
	caption: PropTypes.string,
	captionenabled: PropTypes.string,
};

export const Audio = ({
	id,
	type,
	audioPath,
	bleed,
	caption,
	captionEnabled,
}) => {
	const className = [styles['audio'], 'media', 'audio'];
	if (bleed) {
		className.push('bleed');
	}

	switch (type) {
		case 'mp3':
			type = 'audio/mpeg';
			break;
		default:
			type = 'audio/mpeg';
	}

	return (
		<figure id={id} className={className.join(' ')}>
			<audio controls>
				<source src={audioPath} type="audio/mpeg" />
			</audio>
			{captionEnabled && caption ? <Caption content={caption} /> : null}
		</figure>
	);
};

Audio.propTypes = {
	id: PropTypes.string,
	type: PropTypes.oneOf(['mp3']),
	audioPath: PropTypes.string.isRequired,
	bleed: PropTypes.bool,
	caption: PropTypes.string,
	captionEnabled: PropTypes.bool,
};

const Caption = ({ content }) => {
	return <figcaption dangerouslySetInnerHTML={{ __html: content }} />;
};

Caption.propTypes = {
	content: PropTypes.string,
};
